import { keyframes } from '@emotion/css';
import { Box, Flex, Logo } from '@opendoor/bricks/core';

const pulse = keyframes`
	0% {
		transform: scale(0.9);
	}

	60% {
		transform: scale(1);
	}

	100% {
		transform: scale(0.9);
	}
`;

export interface ILoadingPageWithText {
  text: string;
}

/**
 * FullScreenLoader from Bricks but with text. Growth to add to Bricks if
 * untreated room condition experiment is successful.
 *
 * storybook-check-ignore
 */
export const LoadingPageWithText = (props: ILoadingPageWithText) => (
  <Flex
    bg="neutrals0"
    flexDirection="column"
    width="100%"
    height="100%"
    justifyContent="center"
    alignItems="center"
    p={[5, 7, null, 8]}
    bgColor="brand50"
    data-testid="full-screen-loader"
  >
    <Box animation={`${pulse} 2s infinite`}>
      <Logo variant="secondary" height={100} color="neutrals0" />
    </Box>
    <Box pt="20px" fontSize="s2" fontWeight="semibold" color="neutrals0">
      {props.text}
    </Box>
  </Flex>
);
